// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in .angular-cli.json or (v6 and above) in angular.json.

export const environment = {
  production: true,
  baseURL: 'https://jcvtbnjk10.execute-api.us-east-1.amazonaws.com/dev',  // The PROD backend (in spite of the suffix!)
  gtagTrackingCode: 'UA-157769982-2',  // Google Analytics property code for the PROD environment
  websocketURL: 'wss://nmafwioi3c.execute-api.us-east-1.amazonaws.com/dev'
};

//export const environment = {
//  production: false,
//  baseURL: 'https://kofexh4ee1.execute-api.us-east-1.amazonaws.com/dev',  // The dev back end
//  gtagTrackingCode: 'UA-157769982-1',  // Google Analytics property code, for the dev environment
//  websocketURL: 'wss://o50tf3x2s0.execute-api.us-east-1.amazonaws.com/dev',
//};



// WEBPACK FOOTER //
// ./src/environments/environment.ts